// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2XoU1","buttons":"RemoveExpirationActionButtons_buttons__3gMoa"};